import { render } from "./OurRecentStory.vue?vue&type=template&id=7eba85e4"
import script from "./OurRecentStory.vue?vue&type=script&lang=js"
export * from "./OurRecentStory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__